import React, { useState } from 'react';
import { View, Heading, Text, Flex, Button, Card, Divider } from '@aws-amplify/ui-react';
import { FaUserPlus, FaBook, FaGraduationCap, FaArrowLeft, FaArrowRight, FaMousePointer } from 'react-icons/fa';
import ManualRegistro from '../components/ManualRegistro'; // El componente del teléfono que hicimos

const AyudaPage = () => {
    const [tema, setTema] = useState('registro');

    // Estilo para los botones grandes de selección
    const btnStyle = (active) => ({
        fontSize: '1.4rem',
        padding: '1.5rem',
        height: 'auto',
        backgroundColor: active ? '#C5A059' : '#fff',
        color: active ? 'white' : '#333',
        border: '2px solid #C5A059',
        borderRadius: '15px',
        boxShadow: active ? '0px 10px 20px rgba(197, 160, 89, 0.3)' : 'none'
    });

    return (
        <View padding="2rem" backgroundColor="#f0f2f5" minHeight="100vh">
            {/* TÍTULO PRINCIPAL - LETRA GRANDE */}
            <Flex direction="column" alignItems="center" marginBottom="3rem">
                <Heading level={1} fontSize="3rem" color="#1a1a1a" textAlign="center">
                    Centro de Ayuda Visual
                </Heading>
                <Text fontSize="1.5rem" color="#555" textAlign="center">
                    Seleccione qué desea aprender hoy. Hemos preparado dibujos fáciles para usted.
                </Text>
            </Flex>

            <Flex direction="row" gap="2rem" justifyContent="center" wrap="wrap">
                
                {/* COLUMNA IZQUIERDA: MENÚ DE OPCIONES */}
                <Flex direction="column" gap="1rem" width="350px">
                    <Button 
                        onClick={() => setTema('registro')}
                        style={btnStyle(tema === 'registro')}
                    >
                        <FaUserPlus style={{marginRight: '15px'}} /> Cómo Registrarse
                    </Button>

                    <Button 
                        onClick={() => setTema('libros')}
                        style={btnStyle(tema === 'libros')}
                    >
                        <FaBook style={{marginRight: '15px'}} /> Cómo Comprar Libros
                    </Button>

                    <Button 
                        onClick={() => setTema('cursos')}
                        style={btnStyle(tema === 'cursos')}
                    >
                        <FaGraduationCap style={{marginRight: '15px'}} /> Cómo Ver Cursos
                    </Button>

                    <Card marginTop="2rem" backgroundColor="#fff8e1" border="1px solid #ffe082">
                        <Flex alignItems="center" gap="10px">
                            <FaMousePointer color="#C5A059" />
                            <Text fontWeight="bold" fontSize="1.1rem">Consejo:</Text>
                        </Flex>
                        <Text marginTop="5px" fontSize="1.1rem">
                            Use los botones <b>"Atrás"</b> y <b>"Siguiente"</b> que aparecen dentro del teléfono a la derecha.
                        </Text>
                    </Card>
                </Flex>

                {/* COLUMNA DERECHA: EL SIMULADOR DE TELÉFONO (LA IMAGEN POR CÓDIGO) */}
                <View>
                    {tema === 'registro' ? (
                        <ManualRegistro />
                    ) : (
                        <Card 
                            width="360px" 
                            height="640px" 
                            borderRadius="40px" 
                            border="12px solid #333"
                            backgroundColor="white"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            padding="2rem"
                        >
                            <Flex direction="column" alignItems="center" textAlign="center">
                                <FaBook size="4rem" color="#eee" />
                                <Heading level={3} color="#999" marginTop="1rem">
                                    Guía en construcción
                                </Heading>
                                <Text color="#bbb">
                                    Estamos dibujando esta guía para usted. Muy pronto estará lista.
                                </Text>
                            </Flex>
                        </Card>
                    )}
                </View>

            </Flex>

            {/* PIE DE PÁGINA DE AYUDA */}
            <Divider marginY="4rem" />
            <Flex direction="column" alignItems="center">
                <Text fontSize="1.3rem">¿Aún tiene dudas? Llámenos o escriba al WhatsApp:</Text>
                <Button 
                    marginTop="1rem"
                    backgroundColor="#25D366" 
                    color="white"
                    fontSize="1.5rem"
                    padding="1rem 3rem"
                    onClick={() => window.open('https://wa.me/14078738172')}
                >
                    Hablar con el Dr. Giovanni
                </Button>
            </Flex>
        </View>
    );
};

export default AyudaPage;